import { apiClient } from './api';

export type TransferStatus = 'pending' | 'in_transit' | 'completed' | 'cancelled';

export interface TransferItem {
  id: number;
  sku_id: number;
  sku_code: string;
  product_name: string;
  source_lot_id: number | null;
  quantity: number;
}

export interface StockTransfer {
  id: number;
  transfer_number: string;
  source_location: string;
  destination_location: string;
  status: TransferStatus;
  requested_at: string;
  shipped_at: string | null;
  received_at: string | null;
  notes: string | null;
  created_by_user_id: number;
  items?: TransferItem[];
  created_at: string;
  updated_at: string;
}

export interface ListTransfersFilters {
  page?: number;
  limit?: number;
  status?: TransferStatus;
  source?: string;
  destination?: string;
}

export interface CreateTransferInput {
  source_location: string;
  destination_location: string;
  notes?: string;
  items: Array<{ sku_id: number; quantity: number; source_lot_id?: number }>;
}

export interface PaginatedTransfers {
  data: StockTransfer[];
  pagination: { total: number; page: number; limit: number; pages: number };
}

export async function listTransfers(filters: ListTransfersFilters = {}): Promise<PaginatedTransfers> {
  return apiClient.get<PaginatedTransfers>('/stock-transfers', filters as Record<string, any>);
}

export async function getTransfer(id: number | string): Promise<StockTransfer> {
  return apiClient.get<StockTransfer>(`/stock-transfers/${id}`);
}

export async function createTransfer(input: CreateTransferInput): Promise<StockTransfer> {
  return apiClient.post<StockTransfer>('/stock-transfers', input);
}

export async function updateTransferStatus(id: number | string, status: TransferStatus): Promise<StockTransfer> {
  return apiClient.patch<StockTransfer>(`/stock-transfers/${id}/status`, { status });
}
